import { render } from "./LeechLogo.vue?vue&type=template&id=58b02e54&scoped=true"
import script from "./LeechLogo.vue?vue&type=script&lang=js"
export * from "./LeechLogo.vue?vue&type=script&lang=js"

import "./LeechLogo.vue?vue&type=style&index=0&id=58b02e54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58b02e54"

export default script